
export function tryJsonParse (value: string, failureResult: unknown = undefined): unknown
{
  try
  {
    return JSON.parse(value);
  }
  catch
  {
    return failureResult;
  }
}
